import React from 'react';
import EditorToolbar from '../controls/toolbar/EditorToolbar';
import { useQuill } from '../QuillContext';
import type { Blot } from '../types';
import useLinkShortcut from '../useLinkShortcut';
import applyBlockFormat from './applyBlockFormat';

interface CodeEmbedEditorToolbarProps {
  blot: Blot;
}

const CodeEmbedEditorToolbar = ({ blot }: CodeEmbedEditorToolbarProps) => {
  const { quill, ancestorQuill, readOnly } = useQuill();

  useLinkShortcut();

  return (
    quill &&
    ancestorQuill && (
      <EditorToolbar
        readOnly={readOnly}
        portal={ancestorQuill.container}
        objectButtonOptions={{
          defaultLabel: 'Code block',
          applyFormat: (format) =>
            applyBlockFormat(quill, ancestorQuill, blot, format),
          queryFormat: (format) => ancestorQuill.scroll.query(format),
        }}
      />
    )
  );
};

export default CodeEmbedEditorToolbar;
